export const MY_ACCOUNT_SEARCH = {
  ORDER_DETAILS: 'OrderDetail',
  PENDING_QUOTE_DETAILS: 'PendingQuoteDetails',
  PENDING_ORDER_DETAILS: 'PendingOrderDetails',
  LIST_DETAILS: 'RequisitionListDetailView'
};

export const SHOW_REFERENCE_ID = ['OP', 'QX'];
export const VIEW_ORDER_CTA = ['DL', 'RP', 'PA', 'PU'];

export const NOTIFICATION_ORDER_LINK_TEXT = {
  W: 'REFERENCE_ID',
  N: 'REFERENCE_ID',
  AD: 'REFERENCE_ID',
  H: 'REFERENCE_ID',
  APR: 'REFERENCE_ID',
  OP: 'ORDER',
  OC: 'ORDER',
  OR: 'ORDER',
  NEW: 'QUOTE',
  OH: 'ORDER',
  EX: 'ORDER',
  DL: 'ORDER',
  RP: 'ORDER',
  PA: 'ORDER',
  PU: 'ORDER',
  QX: 'REFERENCE_ID',
  FS: 'ORDER',
  PS: 'ORDER',
  EXP: 'QUOTE',
  E: 'REFERENCE_ID'
};

export const ORDER_STATUS_NOTIFICATION_TRANSLATION_MAP = {
  OR: 'NOTIFICATION_ORDER_RELEASED',
  PS: 'NOTIFICATION_PARTIALLY_SHIPPED',
  FS: 'NOTIFICATION_FULLY_SHIPPED',
  RP: 'NOTIFICATION_PICKED_READY',
  OC: 'NOTIFICATION_CANCELLED',
  EX: 'NOTIFICATION_ORDER_EXCEPTION',
  PU: 'NOTIFICATION_CANCELLED',
  DL: 'NOTIFICATION_DELIVERED',
  N: 'NOTIFICATION_REJECTED',
  AD: 'NOTIFICATION_DELETED',
  PA: 'NOTIFICATION_ORDER_PARTIAL_PICKUP',
  H: 'NOTIFICATION_QUEUED_PROCESSING',
  W: 'NOTIFICATION_PENDING_APPROVAL',
  OP: 'NOTIFICATION_APPROVED',
  OH: 'NOTIFICATION_ON_HOLD',
  APR: 'NOTIFICATION_APPROVED',
  QX: 'NOTIFICATION_FULLY_SHIPPED',
  EXP: 'NOTIFICATION_FULLY_SHIPPED'
};

export const DYNAMIC_NOTIFICATION_TRANSLATION = {
  ...ORDER_STATUS_NOTIFICATION_TRANSLATION_MAP,
  OP: 'NOTIFICATION_QUEUED_PROCESSING',
  APR: 'NOTIFICATION_QUEUED_PROCESSING',
  N: 'NOTIFICATION_QUEUED_PROCESSING',
  AD: 'NOTIFICATION_QUEUED_PROCESSING',
  PS: 'NOTIFICATION_QUEUED_PROCESSING',
  FS: 'NOTIFICATION_QUEUED_PROCESSING',
  DL: 'NOTIFICATION_QUEUED_PROCESSING',
  OR: 'NOTIFICATION_PICKED_READY',
  NEW: 'NOTIFICATION_PICKED_READY',
  E: 'NOTIFICATION_FULLY_SHIPPED',
  EX: 'NOTIFICATION_ORDER_PROBLEM'
};

export const ORDER_STATUS_MAP = {
  RP: 'SHIPPED_STATUS_RP',
  PA: 'PA_READY_STATUS',
  PU: 'SHIPPED_STATUS_PU',
  PS: 'SHIPPED_STATUS_PS',
  FS: 'SHIPPED_STATUS_FS',
  DL: 'SHIPPED_STATUS_DL',
  H: 'QUEUED',
  QX: 'QUEUED_ORDER_UNPROCESSED',
  OC: 'SHIPPED_STATUS_OC',
  OH: 'SHIPPED_STATUS_OH',
  EX: 'SHIPPED_STATUS_EX',
  OR: 'SHIPPED_STATUS_OR',
  E: 'EXPIRED_APPROVAL_STATE',
  W: 'SUBMITTED_FOR_APPROVAL',
  OP: 'SHIPPED_STATUS_OP',
  APR: 'APPROVED_STATUS',
  N: 'CAT_ORD_REJECTED',
  AD: 'CAT_ORD_DELETED',
  NEW: 'QUOTE_EXPIRING',
  EXP: 'EXPIRED_STATE'
};

export const NOTIFICATIONS_STATUS_MAP = {
  ...ORDER_STATUS_MAP,
  PA: 'PARTIALLY_READY_PICKUP',
  H: 'QUEUED_FOR_PROCESSING',
  RP: 'SHIPPED_STATUS_RP',
  OR: 'SHIPPED_STATUS_OR',
  EX: 'ORDER_PROBLEM',
  W: 'SUBMITTED_FOR_APPROVAL',
  APR: 'Approval_Status_Approved',
  OH: 'SHIPPED_STATUS_OH',
  OP: 'PLACED',
  OC: 'CANCELLED_STATE',
  EXP: 'EXPIRED_STATE'
};

export const NOTIFICATION_HEADER_STATUS = {
  ...NOTIFICATIONS_STATUS_MAP,
  PS: 'MO_OrderStatus_V',
  H: 'QUEUED',
  QX: 'NOT_PROCESSED',
  OR: 'CREDIT_CARD_PROCESSING',
  NEW: 'EXPIRING_TODAY',
  E: 'NOTIF_PREF_EXPIRED_APPROVAL_TITLE',
  EX: 'ORDER_PROBLEM'
};

export const NOTIFICATION_ORDER_STATUS_MAP = {
  ...NOTIFICATIONS_STATUS_MAP,
  PS: 'MO_OrderStatus_V',
  QX: 'QUEUED_ORDER_NOT_PROCESSED_HEADING',
  NEW: 'EXPIRING_TODAY',
  E: 'NOTIF_PREF_EXPIRED_APPROVAL_TITLE',
  EX: 'ORDER_PROBLEM'
};

export const NOTIFICATION_INDICATOR = {
  OH: 'CONTACT_YOUR_DEALER',
  EX: 'CONTACT_YOUR_DEALER',
  W: 'REVIEW_ORDER',
  DL: 'VIEW_ORDER',
  RP: 'VIEW_ORDER',
  PA: 'VIEW_ORDER',
  PU: 'VIEW_ORDER',
  FS: 'TRACK_ORDER',
  PS: 'TRACK_ORDER',
  NEW: 'REVIEW_QUOTE',
  QX: 'RESUBMIT_ORDER_CTA',
  EXP: 'VIEW_QUOTE',
  E: 'RESUBMIT_ORDER_CTA'
};

export const VARIANT_TYPES = {
  SUCCESS: 'active',
  WARNING: 'warning',
  CANCELED: 'in-determined',
  ERROR: 'error',
  DEFAULT: undefined,
  CAUTION: undefined
};

export const NOTIFICATION_LABEL_TYPE_MAP = {
  W: VARIANT_TYPES.DEFAULT,
  APR: VARIANT_TYPES.SUCCESS,
  OP: VARIANT_TYPES.SUCCESS,
  OR: VARIANT_TYPES.SUCCESS,
  H: VARIANT_TYPES.SUCCESS,
  AD: VARIANT_TYPES.ERROR,
  OH: VARIANT_TYPES.ERROR,
  EX: VARIANT_TYPES.ERROR,
  N: VARIANT_TYPES.ERROR,
  OC: VARIANT_TYPES.CANCELED,
  DL: VARIANT_TYPES.SUCCESS,
  PU: VARIANT_TYPES.SUCCESS,
  NEW: VARIANT_TYPES.ERROR,
  RP: VARIANT_TYPES.CAUTION,
  PA: VARIANT_TYPES.CAUTION,
  E: VARIANT_TYPES.ERROR,
  QX: VARIANT_TYPES.ERROR,
  PROCESSED: VARIANT_TYPES.SUCCESS,
  FS: VARIANT_TYPES.CAUTION,
  PS: VARIANT_TYPES.CAUTION
};
